import { useEffect, useMemo } from 'react';
import { SelectCompact, VStack } from '@direct-frontend/components';
import { type OpenApiSchemaBasicPage } from '#shared/api/schema';
import { LinkWithIcon } from '#shared/components/LinkWithIcon';
import { type ConstructorPageTemplateSelectProps } from './types';

export type ConstructorPageTemplateSelectUIProps = ConstructorPageTemplateSelectProps & {
    templates?: OpenApiSchemaBasicPage[];
    openConstructor?: VoidFunction;
};

export const ConstructorPageTemplateSelectUI = (props: ConstructorPageTemplateSelectUIProps) => {
    const {
        alias,
        value,
        templates,
        openConstructor,
        label = 'Шаблон страницы',
        onChange,
        onDefaultValueAutoSelect,
        ...rest
    } = props;
    const items = useMemo(() => {
        if (!templates) {
            return [];
        }

        return templates.map((item) => {
            return {
                value: item.id,
                content: item.variant_type === 'default' ? 'Шаблон по умолчанию' : item.title,
            };
        });
    }, [templates]);

    useEffect(() => {
        if (value) {
            return;
        }

        const baseTemplate = templates?.find((item) => item.variant_type === 'default');

        if (baseTemplate) {
            (onDefaultValueAutoSelect ?? onChange)(baseTemplate.id);
        }
    }, [onChange, onDefaultValueAutoSelect, templates, value]);

    return (
        <VStack gap="6">
            <SelectCompact
                {...rest}
                onChange={onChange}
                label={label}
                value={value}
                items={items}
                size="m"
                color="contour"
                matchTriggerWidth
            />
            <LinkWithIcon onClick={openConstructor}>Показать дизайн этого шаблона в редакторе</LinkWithIcon>
        </VStack>
    );
};
